import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CROSS } from 'src/defaultImages.js';
import { DateService } from 'src/app/common/services/date.service';

@Component({
  selector: 'app-custom-timings',
  templateUrl: './custom-timings.component.html',
  styleUrls: ['./custom-timings.component.css'],
})
export class CustomTimingsComponent implements OnInit {
  customTimings: FormGroup;
  images: any = {
    CROSS: CROSS,
  };
  translationText: any;
  isCustomBtnVisible: boolean = true;
  subscription = new Subscription();
  isSameDay: boolean = true;
  isBothTimeSelected: boolean = false;

  constructor(
    private _fb: FormBuilder,
    private _dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _translateService: TranslateService,
    private _dateService: DateService
  ) {}

  ngOnInit() {
    this.initCustomTimingsForm();
    this.setTranslation();
    this.listenFormGroupChanges();
  }

  initCustomTimingsForm() {
    this.customTimings = this._fb.group({
      time1: [null, Validators.required],
      time2: [null, Validators.required],
    });
  }

  setTranslation() {
    this.subscription.add(
      this._translateService.get(['CUSTOM_TIMINGS']).subscribe((res) => {
        this.translationText = res.DATES_ORDER;
      })
    );
  }

  listenFormGroupChanges(): void {
    this.customTimings.valueChanges.subscribe(() => {
      this.updateIsSameDay();
    });
  }

  updateIsSameDay(): void {
    const startTime = this.customTimings.get('time1').value;
    const endTime = this.customTimings.get('time2').value;
    if (startTime && endTime) {
      this.isBothTimeSelected = true;
      this.isSameDay = this._dateService.areTimesOnSameDay(startTime, endTime);
    } else {
      this.isBothTimeSelected = false;
    }
  }

  showOnlyTime(time) {
    if (time === '' || time === null) return `  --:--  `;
    else {
      let d = new Date(time);
      let hour =
        d.getHours() == 0
          ? 12
          : d.getHours() > 12
          ? d.getHours() - 12
          : d.getHours();
      let min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
      let hh = hour < 10 ? '0' + hour : hour;
      let ampm = d.getHours() < 12 ? 'AM' : 'PM';
      let format = hh + ':' + min + ' ' + ampm;
      return format;
    }
  }

  cancelClicked() {
    this._dialogRef.close({ data: 'closed' });
  }

  setTime() {
    const startTime = this.customTimings.get('time1').value;
    const endTime = this.customTimings.get('time2').value;

    if (startTime && endTime) {
      const customTimeRange = {
        start: startTime,
        end: endTime,
      };

      // Send the customTimeRange back to the parent component
      this._dialogRef.close({ data: customTimeRange });
    }
  }
}
